import { PrimaryPostTradeWorkspace } from 'components/Workspaces/PrimaryPostTrade';

export default PrimaryPostTradeWorkspace;
